"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var GwsGameProvidersZonesListCtl = /** @class */ (function (_super) {
    __extends(GwsGameProvidersZonesListCtl, _super);
    function GwsGameProvidersZonesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_operator_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.operator_id; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this.dk_is_default_streamer_zone = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_default_streamer_zone; });
        _this._errDialog = errDialog;
        return _this;
    }
    GwsGameProvidersZonesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    GwsGameProvidersZonesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    GwsGameProvidersZonesListCtl.prototype.LoadData = function (key, onDone) {
        var _this = this;
        webAApi_1.ListGwsGameProviderZonesByGameProviderIdGet.exec({
            gws_gameprovider_id: key
        }, function (resp) {
            _this.DATA.data = [];
            //
            _this.DATA.total = resp.total_count;
            //
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    title: resp.list[i].title,
                    description: resp.list[i].description,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    operator_id: resp.list[i].operator_id,
                    is_default_streamer_zone: resp.list[i].is_default_streamer_zone
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    GwsGameProvidersZonesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddGwsGameProviderZone.exec({
            data: {
                gws_gameprovider_id: data.gws_gameprovider_id,
                operator_id: data.operator_id,
                title: data.title,
                description: data.description,
                is_default_streamer_zone: data.is_default_streamer_zone
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_added_uts_ms).utc(false),
                title: data.title,
                operator_id: data.operator_id,
                description: data.description,
                is_default_streamer_zone: data.is_default_streamer_zone
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    GwsGameProvidersZonesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditGwsGameProviderZone.exec({
                data: {
                    gws_gameprovider_zone_id: data.key,
                    operator_id: data.operator_id,
                    title: data.title,
                    description: data.description,
                    is_default_streamer_zone: data.is_default_streamer_zone
                }
            }, function (resp) {
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.title = data.title;
                _tmp.operator_id = data.operator_id;
                _tmp.description = data.description;
                _tmp.is_default_streamer_zone = data.is_default_streamer_zone;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    GwsGameProvidersZonesListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    GwsGameProvidersZonesListCtl.prototype.DeleteData = function (GameProviderZoneKey, onDone) {
        var _this = this;
        var _tmp = this.getById(GameProviderZoneKey);
        if (_tmp) {
            webAApi_1.DoDeleteGwsGameProviderZone.exec({
                data: {
                    gws_gameprovider_zone_id: GameProviderZoneKey
                }
            }, function (resp) {
                _this.RemoveItem(GameProviderZoneKey);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return GwsGameProvidersZonesListCtl;
}(BaseController_1.BaseController));
exports.GwsGameProvidersZonesListCtl = GwsGameProvidersZonesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gws_gameproviders_list/ctl/GwsGameProviderZonesListCtl.ts
// module id = 1024
// module chunks = 0